import { AutoComplete, Form } from "antd";
import { useState } from "react";
import debounce from "lodash.debounce";

const LocationAutoCompleteShipment = ({
  form,
  locationList,
  handleAddressPlaceSelect,
  fieldName,
  label,
  width = "262px",
  className="",
  required=false,
  placeholder='',
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const fetchGooglePlaces = debounce((input) => {
    if (!input) return;

    const service = new window.google.maps.places.AutocompleteService();
    service.getPlacePredictions({ input }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setOptions(
          predictions.map((prediction) => ({
            label: prediction?.description,
            value: prediction?.place_id,
            source: "google",
          }))
        );
      }
    });
  }, 300);

  const fetchPlaceDetails = (placeId) => {
    return new Promise((resolve, reject) => {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails(
        { placeId, fields: ["formatted_address", "geometry", "name"] },
        (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            resolve({
              name: place.name,
              address: place.formatted_address,
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng(),
            });
          } else {
            reject(status);
          }
        }
      );
    });
  };

  const handleSearch = (input) => {
    setInputValue(input);

    if (!input) {
      setOptions([]);
      return;
    }

    const localMatches = locationList
      .filter((location) =>
        location.name.toLowerCase().includes(input.toLowerCase())
      )
      .map((location) => ({
        label: location.name,
        value: location.id,
        source: "api",
      }));

    if (localMatches.length > 0) {
      setOptions(localMatches);
    } else {
      fetchGooglePlaces(input);
    }
  };

  const handleSelect = async (value, option) => {
    setInputValue(option.label);

    if (option.source === "api") {
      const selectedLocation = locationList.find((loc) => loc.id === option.keyId);
      if (selectedLocation) {
        handleAddressPlaceSelect(selectedLocation);
      }
    } else if (option.source === "google") {
      try {
       // handleAddressPlaceSelect({ name: option.label, id: value }, fieldName);
        const placeDetails = await fetchPlaceDetails(value);
         handleAddressPlaceSelect({ ...placeDetails, id: value , placeName:option.label }, fieldName);
      } catch (error) {
        console.error("Failed to fetch place details: ", error);
      }
    }
  };

  return (
    <Form.Item
      label={label}
      name={fieldName}
      // rules={[{ required: required, message: "Please select location" }]}
      
      style={{ marginBottom: "16px", width: width }}
      className={className}
    >
      <AutoComplete
        style={{
          width: "100%",
          boxShadow: "none",
          height: "36px",
          backgroundColor: "#F3F3F3",
          color: "#5E5E5E",
          borderRadius: "8px",
        }}
        options={options.map((option) => ({
          label: option.label,
          value: option.label,
          source: option.source,
          keyId: option.value,
        }))}
        value={inputValue}
        onSearch={handleSearch}
        onSelect={(value, option) => handleSelect(option.keyId, option)}
        onChange={setInputValue}
        placeholder={placeholder ? placeholder : `Select ${label}`}
      />
    </Form.Item>
  );
};


export default LocationAutoCompleteShipment;
